<template>
	<div class="ad-templates">
		<div class="layout-grid-header">
			<div class="ui labeled icon button create-template-button" @click="createLayout"><i class="plus icon"></i>Create Template</div>
		</div>

		<div class="ui five doubling stackable cards">
			<ad-template v-for="layout in layouts" :key="layout.id"
				:layout="layout"
				:default-book-format="defaultBookFormat"
				@deleteLayout="deleteLayout"
				@insertLayout="insertLayout"
				@updateSpecialId="updateSpecialId"
				:global="global"
				:is-studio="isStudio" />
			<div class="ui inverted active dimmer" v-if="loading"><div class="ui text loader">Loading</div></div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['global', 'orgId', 'selectedBookFormat', 'isStudio'],
	data() {
		return {
			loading: false,
			layouts: [],
			defaultBookFormat: null,
			adSizes: [],
			categoryId: null
		};
	},
	methods: {
		loadTemplates() {
			this.loading = true;

			let url = 'ajax/getAdTemplates.php';
			if(this.global) {
				url += '?isGlobal=true';
			} else if(this.orgId) {
				url += '?orgId=' + this.orgId;
			}

			$.proxyAjax({
				url,
				dataType: 'json',
				success: (data) => {
					this.layouts.forEach(layout => {
						if(!layout.specialId) {
							layout.specialId = null;
						}
					});

					this.layouts = data.layouts;
					if(this.selectedBookFormat) {
						this.defaultBookFormat = this.selectedBookFormat;
					} else {
						this.defaultBookFormat = data.defaultBookFormat;
					}
					this.adSizes = data.sizes;
					this.categoryId = data.category.id;
					this.loading = false;

					this.layouts.sortByKey('order');
				},
				error: () => {
					$.Alert('Error', 'Failed to load templates');
					this.loading = false;
				}
			})
		},
		createLayout() {
			$.SettingsBuilderDialog([
				{
					id: 'name',
					type: 'text',
					description: 'Name'
				},
				{
					id: 'adSize',
					type: 'dropdown',
					description: 'Ad Size',
					options: this.adSizes
				}
			], {
				title: 'Create Ad Template',
				onSettingsApplied: (settings) => {
					this.insertLayout(settings, true);
				}
			});
		},
		insertLayout(settings, goToComposer = false) {
			this.loading = true;
			$.ajax({
				url: 'ajax/createLayout.php',
				data: {
					categoryId: this.categoryId,
					layoutName: settings.name,
					definition: settings.definition ?? {},
					type: 'Ad Template',
					subType: settings.adSize
				},
				type: 'POST',
				dataType: 'json',
				success: (data) => {
					if(goToComposer) {
						if(this.defaultBookFormat && this.defaultBookFormat.formatId) {
							window.location = '/Composer.php?layoutId=' + data.layout.layoutId + '&formatId=' + this.defaultBookFormat.formatId;
						} else {
							window.location = '/Composer.php?layoutId=' + data.layout.layoutId;
						}
					} else {
						data.layout.specialId = null;
						this.layouts.push(data.layout);
						this.loading = false;
					}
				},
				error: (xhr) => {
					if(xhr.responseJSON && xhr.responseJSON.reason && xhr.responseJSON.reason.indexOf('name already exists') !== -1) {
						$.Alert('Error', 'A layout with the name "' + settings.name + '" already exists');
					} else {
						$.Alert('Error', 'Failed to create new layout');
					}

					this.loading = false;
				}
			});
		},

		deleteLayout: function(layout) {
			this.layouts.removeItem(layout);
		},
		updateSpecialId(layout, specialId) {
			this.layouts.forEach(layout => {
				if(layout.specialId === specialId) {
					layout.specialId = null;
				}
			})
			layout.specialId = specialId;
		}
	},
	mounted() {
		this.loadTemplates();
	}
};
</script>

<style scoped>
.layout-grid-header {
	margin-bottom: 1em;
}
</style>